import FaqContainer from "../../../components/pages/other/faq";

const Faq = () => {
  return <FaqContainer />;
};

export default Faq;
